"use client";

import clsx from "clsx";
import type React from "react";
import PortalPage from "src/components/app/PortalPage/PortalPage";
import { useSearchParams } from "src/lib/Navigation";
import styles from "./DocPage.module.scss";

export interface DocPageProps {
  children?: React.ReactNode;
}

const DocPage = (props: DocPageProps) => {
  const { children } = props;
  let embedded = false;
  const searchParams = useSearchParams();
  if (searchParams.get("embedded") === "true") {
    embedded = true;
  }

  return (
    <PortalPage className={clsx(styles.page, embedded && styles.embedded)}>{children}</PortalPage>
  );
};

export default DocPage;
